module.exports = __webpack_public_path__ + "static/media/hyundai-thumbs.c5aba6c0.svg";